import React from "react";
import axios from "axios";
import { BACKEND_URL } from "../config/Constant";
import api from "../utils/axiosInstance";

const API = "contactlist";

const token = localStorage.getItem("Token");

export const createContactList = async (data) => {
  try {
    const response = await api.post(`${BACKEND_URL}/${API}/create`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getContactList = async () => {
  try {
    const response = await api.post(
      `${BACKEND_URL}/${API}/contactlist`,

      null
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const editContactList = async (data) => {
  try {
    const response = await api.post(`${BACKEND_URL}/${API}/update`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateFileUpload = async (data) => {
  try {
    const response = await api.post(
      `${BACKEND_URL}/${API}/uploadcontacts`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteContactList = async (id) => {
  const data = {
    listId: id,
  };

  try {
    const response = await api.post(
      `${BACKEND_URL}/${API}/deletecontactlist`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const createOneContact = async (data) => {
  try {
    const response = await api.post(`${BACKEND_URL}/${API}/addcontact`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getOneMemberList = async (data) => {
  const listId = {
    listId: data,
  };
  try {
    const response = await api.post(
      `${BACKEND_URL}/${API}/getmemberlist`,
      listId
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteContactMember = async (data) => {
  try {
    const response = await api.post(
      `${BACKEND_URL}/${API}/deletecontact`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const updateContactMember = async (data) => {
  try {
    const response = await api.post(`${BACKEND_URL}/${API}/editcontact`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const createPhoneNumber = async (data) => {
  try {
    const response = await api.post(`${BACKEND_URL}/${API}/addnumber`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updatePhoneNumber = async (data) => {
  try {
    const response = await api.post(`${BACKEND_URL}/${API}/editnumber`, data);
    return response;
  } catch (error) {
    return error;
  }
}

export const deletePhoneNumber = async (data) => {
  try {
    const response = await api.post(
      `${BACKEND_URL}/${API}/deletenumber`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};